import RouterProvider from '@Components/RouterProvider';
import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import CostUpdaterForm from '../components/FormCostUpdater';
import URLGeneratorForm from '../components/FormURLGenerator';
import AllocationsGrid from '../components/Grid';
import { AllocationProvider } from '../store';

export default function AllocationsGridLayout() {
  return <RouterProvider>
    <AllocationProvider>
      <AllocationsGrid />
      <Router>
        <PrivateRoute path="/offer/allocations/:id/generator" component={URLGeneratorForm} />
        <PrivateRoute path="/offer/allocations/:id/cost-updater" component={CostUpdaterForm} />
      </Router>
    </AllocationProvider>
  </RouterProvider>
}
